/** @file The slots any skin maps an attachment into (each slot once, in skin order). */
import type { Doc, Id } from '@pose2d/format/types';

/** Ids of every slot that some skin entry maps to `attId`. */
export function slotsHolding(doc: Doc, attId: Id): Id[] {
  const slots = Object.values(doc.skins).flatMap((skin) => skin.entries.filter((e) => e.attachment === attId).map((e) => e.slot));
  return [...new Set(slots)];
}
